import React from "react";
import styles from "./SkeletonLoaderCardSlim.module.scss";

export default function SkeletonLoaderCardSlim() {
    return (
        <div className={styles["card"]}>
            <div className={styles["card-image"]} />
            {/*<div className={styles["card-content-wrapper"]}>*/}
            {/*    <h2 className={styles["card-content"]}/>*/}
            {/*</div>*/}
        </div>
    );
}
